export default (maxClickpathCount) => {
	const clickPath = JSON.parse(
		sessionStorage.getItem('ws-tracking-clickpath') || '{}'
	);
	const clickPathValue = Object.keys(clickPath)
		.map((key) => {
			const { viewType, timestamp, path } = clickPath[key];
			return `${timestamp}|${viewType}|${path}`;
		})
		.reverse()
		.slice(0, maxClickpathCount)
		.join('^');

	const $clickPathInput = document.createElement('input');
	$clickPathInput.type = 'hidden';
	$clickPathInput.name = 'clickpath';
	$clickPathInput.value = clickPathValue;

	window.DDC.dataLayer.events.listener.listen(
		'ddc.form.submission',
		({ element }) => {
			if (element && element.closest('form')) {
				element.closest('form').appendChild($clickPathInput);
			}
		}
	);
};
